import React from 'react';
import { NikeRoute } from 'nike-ui/src/common/routing/types';
import { getPathnameFromRoute } from 'nike-ui/src/common/routing/utils';
import clsx from 'clsx';
import i18n from '@i18n';
import { fireGAEvent } from '@/analytics';

import {
    ABOUT_US,
    CLUB_NIKE,
    COLLABORATION,
    CONTACT_US,
    FOR_PLAYERS,
    LAW,
    SCRATCHCARD_OVERVIEW
} from '@/routing/routes';
import { navigate } from '@/routing';
import { showCookiebotDialog } from 'nike-ui/src/components/cookie';
import { initializeCookieBotMobile } from '@/cookie-consent';
import { clearCashinClosingMode } from 'nike-ui/src/components/ticketus/handlers';
import { dispatch } from 'nike-re-framejs';

import InfoCircleIcon from 'nike-ui/src/icons/svg/info-circle-icon-sv.svg';
import MailIcon from 'nike-ui/src/icons/svg/mail-icon-sv.svg';
import NikeLogoNewIcon from 'nike-ui/src/icons/svg/nike-logo-new-icon-sv.svg';
import ForPlayersIcon from 'nike-ui/src/icons/svg/for-players-icon-sv.svg';
import LotteryIcon from 'nike-ui/src/icons/svg/lottery-icon-sv.svg';
import CollaborationIcon from 'nike-ui/src/icons/svg/collaboration-icon-sv.svg';
import PersonCircleIcon from 'nike-ui/src/icons/svg/person-circle-icon-sv.svg';
import LawIcon from 'nike-ui/src/icons/svg/law-icon-sv.svg';

export const FooterLinks = () => (
    <>
        <FooterLink
            route={ABOUT_US}
            iconTab={<InfoCircleIcon />}
            data-atid="footer-link-about"
            label={i18n('footer.about')}
        />
        <FooterLink
            route={CONTACT_US}
            iconTab={<MailIcon />}
            data-atid="footer-link-contact-us"
            label={i18n('footer.contact-us')}
        />
        <FooterLink
            route={FOR_PLAYERS}
            iconTab={<ForPlayersIcon />}
            data-atid="footer-link-for-players"
            label={i18n('react.page.title.FOR_PLAYERS')}
        />
        <FooterLink
            route={CLUB_NIKE}
            iconTab={<NikeLogoNewIcon />}
            data-atid="footer-link-klub"
            label={i18n('jsp.header.klubnike')}
        />
        <FooterLink
            route={SCRATCHCARD_OVERVIEW}
            iconTab={<LotteryIcon />}
            data-atid="footer-link-lottery"
            label={i18n('jsp.header.zreby')}
        />
        <FooterLink
            route={COLLABORATION}
            iconTab={<CollaborationIcon />}
            data-atid="footer-link-collaboration"
            label={i18n('head.title.page::COLLABORATION')}
        />
        <FooterLink
            href="https://kariera.nike.sk/"
            iconTab={<PersonCircleIcon />}
            data-atid="footer-link-career"
            label={i18n('react.footer.careers')}
            target="_blank"
        />
        <FooterLink
            route={LAW}
            iconTab={<LawIcon />}
            data-atid="footer-link-law"
            label={i18n('react.page.title.LAW')}
        />
        <PrivacyFooterLink />
    </>
);

const PrivacyFooterLink = () => {
    const handleClick: React.MouseEventHandler = async _e => {
        await initializeCookieBotMobile();
        showCookiebotDialog();
    };
    return <FooterLink onClick={handleClick} label={i18n('nui.privacy.settings')} data-atid="footer-link-privacy" />;
};

interface FooterLinkProps {
    iconTab?: React.ReactNode;
    label: string;
    href?: string;
    route?: NikeRoute;
    'data-atid': string;
    className?: string;
    onClick?: React.EventHandler<any>;
    target?: string;
}

function FooterLink({
    iconTab: Icon,
    label,
    route,
    className,
    href,
    target,
    'data-atid': dataAtid,
    onClick
}: FooterLinkProps) {
    const _href = route && !href ? getPathnameFromRoute(route, {}) : href;

    const handleClick = e => {
        fireGAEvent('Paticka', label);
        dispatch(clearCashinClosingMode);
        if (onClick) {
            onClick(e);
            return;
        }
        if (route && !href) {
            e.preventDefault();
            navigate(route);
        }
    };

    return (
        <a
            className={clsx('ripple link-box', className)}
            href={_href}
            onClick={handleClick}
            target={target}
            data-atid={dataAtid}
        >
            {Icon}
            <h3>{label}</h3>
        </a>
    );
}
